import React, { useState, useEffect } from 'react';
import './Pie.css';
import Slice from './Slices/Slices';
import Questions from './Questions/Questions';


const Pie = ({ colors, langId, handleClick, baseColors, startQuestions, startCategories }) => {


  const [slices, setSlices] = useState({});

  const [hoverQuestion, setHoverQuestion] = useState(null);
  const [coordinates, setCoordinates] = useState({ x: 0, y: 0 });

  function hexToRgba(hex, opacity) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Parse the r, g, b values
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Return the RGBA color
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }


  useEffect(() => {
    const handleMouseMove = (event) => {
      setCoordinates({
        x: event.clientX,
        y: event.clientY,
      });
    };

    // Add event listener for mousemove
    window.addEventListener('mousemove', handleMouseMove);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []); // Empty dependency array ensures this effect runs only once


  useEffect(() => {

    const limit = Object.values(startQuestions).length;
    let temp = {};
    let number = 1;
    let startAngle = 0;

    let colors = baseColors;
    Object.values(startCategories).map((category) => {
      let radius = (360 / limit) * category.taxonomies.length;


      temp[number] = { score: category.score, startAngle: startAngle, radius: radius, question: category?.lang[langId]?.title.split("Competentie ").join(""), fill: hexToRgba(colors[number - 1], 0.2), transform: '1.2' };
      number++
      startAngle += radius;

    })



    setCategories(temp);
  }, [startCategories]);

  useEffect(() => {

    let temp = {};
    let number = 1;



    Object.values(startQuestions).map((question) => {
      let color = colors[number - 1];
      //"#FF0000";



      const score = question.score === 10 ? '1' : '0.' + question.score;


      temp[number] = { transform: score, question: question?.lang[langId]?.title, fill: color };
      number++

    })



    setSlices({ ...temp });
  }, [startQuestions]);





  const [categories, setCategories] = useState({});


  function selectScore(e, question) {

    const targetValue = e.target.value === '10' ? '1' : '0.' + e.target.value

    slices[question].transform = targetValue;

    setSlices({ ...slices });


  }

  function handleMouseEnter(event, key) {


    let hover = Object.values(startQuestions)[key - 1];

    hover.index = key - 1;


    setHoverQuestion(hover);
  };

  function handleMouseLeave() {
    setHoverQuestion(null);

  };


  return (
    <>


      {hoverQuestion &&

        <div style={{ backgroundColor: colors[hoverQuestion.index], left: coordinates.x + 20 + 'px', top: coordinates.y + 20 + 'px' }} className="rounded-xl px-5 z-20  py-2 fixed">{hoverQuestion?.lang[langId]?.title}</div>

      }

      <div className="Content flex justify-center mb-10">

        <div className="QuestionsBlock hidden">
          <ul>
            <Questions
              slices={slices}
              selectScore={selectScore}
            />
          </ul>
        </div>
        <div className="ChartBlock">
          <div className="ChartPie" style={{ width: '610px' }}>
            <svg id="svgElement" className="ChartPieChunk" width="550px" height="550px" viewBox="0 0 550 550" xmlns="http://www.w3.org/2000/svg">

              <circle cx="275" cy="245" r="200" fill="#EFEFEF" stroke="#E3E3E3" strokeWidth="1"></circle>
              <Slice
                slices={slices} categories={categories} startCategories={startCategories}
                handleMouseEnter={handleMouseEnter}
                handleClick={handleClick}
                handleMouseLeave={handleMouseLeave}
              />


            </svg>
          </div>
        </div>
      </div>
    </>
  );

}

export default Pie;
